/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import deviceCredentialsTemplate from '../../../../../device/device-credentials.tpl.html';
import editAssetDeviceTemplate from './edit-asset-device.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.editAssetDevice', [])
    .directive('agEditAssetDevice', EditAssetDevice)
    .name;

/*@ngInject*/
function EditAssetDevice() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            deviceId: '=',
            assetId: '=',
            assetType: '='
        },
        controller: EditAssetDeviceController,
        controllerAs: 'vm',
        templateUrl: editAssetDeviceTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function EditAssetDeviceController($rootScope, $scope, $timeout, $document, $mdDialog, $translate, agTypes, userService, agDeviceService) {

    let vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.device = null;
    vm.deviceTypes = [];
    vm.agTypes = agTypes;

    vm.copyDevice = copyDevice;
    vm.moveDevice = moveDevice;
    vm.manageCredentials = manageCredentials;
    vm.save = save;
    vm.cancel = cancel;

    $scope.$watch('vm.deviceId', function() {
        if (vm.showData) {
            reload(vm.deviceId, vm.assetId, vm.assetType);
        }
    });

    function reload(deviceId, parentAssetId, parentAssetType) {
        if (!vm.device || !angular.equals(vm.device.id, deviceId)) {
            vm.loading = true;
            vm.origDevice = null;
            vm.device = null;
            vm.parentAssetId = parentAssetId;
            vm.parentAssetType = parentAssetType;
            if (deviceId && parentAssetType) {
                if (parentAssetType === agTypes.assetType.silo) {
                    vm.deviceTypes = [agTypes.deviceType.temperatureSensorLines, agTypes.deviceType.moistureSensorLines, agTypes.deviceType.co2SensorLines, agTypes.deviceType.levelIndicator, agTypes.deviceType.headSpaceSensor, agTypes.deviceType.headSpaceSensor2000];
                    agDeviceService.getDevice(deviceId).then(
                        function success(device) {
                            vm.origDevice = device;
                            vm.device = angular.copy(device);
                            vm.loading = false;
                            resetFormState();
                        }
                    );
                } else if (parentAssetType == agTypes.assetType.aeration) {
                    vm.deviceTypes = [agTypes.deviceType.relay];
                    agDeviceService.getRelay(deviceId).then(
                        function success(device) {
                            vm.origDevice = device;
                            vm.device = angular.copy(device);
                            vm.loading = false;
                            resetFormState();
                        }
                    );
                }  else if (parentAssetType == agTypes.assetType.weatherStation) {
                    vm.deviceTypes = [agTypes.deviceType.weatherStation];
                    agDeviceService.getWeatherStation(deviceId).then(
                        function success(device) {
                            vm.origDevice = device;
                            vm.device = angular.copy(device);
                            vm.loading = false;
                            resetFormState();
                        }
                    );
                }
            } else {
                vm.loading = false;
            }
        }
    }

    function resetFormState() {
        $timeout(function() {
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
        });
    }

    function copyDevice($event) {
        agDeviceService.copyDeviceDialog($event, vm.origDevice).then(
            function() {
                $rootScope.$broadcast('deviceCopied');
            }
        );
    }

    function moveDevice($event) {
        agDeviceService.moveDeviceDialog($event, vm.origDevice, vm.assetId).then(
            function() {
                reload();
                $rootScope.$broadcast('deviceMoved');
            }
        );
    }

    function manageCredentials($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'ManageDeviceCredentialsController',
            controllerAs: 'vm',
            templateUrl: deviceCredentialsTemplate,
            locals: {deviceId: vm.device.id.id, isReadOnly: false},
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
        }, function () {
        });
    }

    function cancel() {
        vm.device = angular.copy(vm.origDevice);
        resetFormState();
    }

    function save() {
        var savePromise;
        if (vm.parentAssetType == agTypes.assetType.silo) {
            savePromise = agDeviceService.saveDevice(vm.device);
        } else if (vm.parentAssetType == agTypes.assetType.aeration) {
            savePromise = agDeviceService.saveRelay(vm.device);
            $scope.theForm.$setPristine();
        } else if (vm.parentAssetType == agTypes.assetType.weatherStation) {
            savePromise = agDeviceService.saveWeatherStation(vm.device);
        }
        savePromise.then(function success(device) {
            vm.origDevice = device;
            vm.device = angular.copy(device);
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
            $rootScope.$broadcast('deviceUpdated', vm.origDevice);
        });
    }

}

